module.exports = __webpack_public_path__ + "static/media/jr.bcd92889.png";